import {goldSealMiscServiceId} from 'root-config/constants.js'

export default function isGoldSealProtection (product) {
  return product.miscserviceid === goldSealMiscServiceId
}
